import TextareaAutogrow from "stimulus-textarea-autogrow";

export default class extends TextareaAutogrow {
  connect() {
    super.connect();

    // Ensure the autogrow is applied after the initial render
    // This is necessary because the textarea might not have the correct height
    // immediately after the page loads, especially if it is dynamically inserted.
    setTimeout(() => {
      this.autogrow();
    }, 150);
  }
}
